import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "react-feather";
import ReactPlayer from "react-player";

const VideoGallerySliderComp = ({
  videoSlides,
  autoSlide = false,
  autoSlideInterval = 10000,
  videoHeight = "540px",
}) => {
  const [current, setCurrent] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const prev = () => {
    setIsPlaying(false);
    setCurrent((current) =>
      current === 0 ? videoSlides.length - 1 : current - 1
    );
  };

  const next = () => {
    setIsPlaying(false);
    setCurrent((current) =>
      current === videoSlides.length - 1 ? 0 : current + 1
    );
  };

  useEffect(() => {
    if (autoSlide) {
      const slideInterval = setInterval(next, autoSlideInterval);
      return () => clearInterval(slideInterval);
    }
  }, [autoSlide, autoSlideInterval, next]);

  return (
    <div className="w-[960px] relative group">
      <div className="relative w-full h-[540px] bg-black/5 rounded-lg overflow-hidden">
        <ReactPlayer
          url={videoSlides[current]}
          controls={true}
          width="100%"
          height="100%"
          playing={isPlaying}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onEnded={() => setIsPlaying(false)}
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </div>

      {/* Navigation buttons - hidden by default, shown on hover */}
      <div className="absolute inset-0 flex items-center justify-between px-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        <button
          onClick={prev}
          className="p-2 rounded-full bg-white/90 text-primary-600 shadow-lg hover:bg-white hover:text-primary-700 transition-all duration-300 transform hover:scale-110 pointer-events-auto"
        >
          <ChevronLeft size={32} />
        </button>
        <button
          onClick={next}
          className="p-2 rounded-full bg-white/90 text-primary-600 shadow-lg hover:bg-white hover:text-primary-700 transition-all duration-300 transform hover:scale-110 pointer-events-auto"
        >
          <ChevronRight size={32} />
        </button>
      </div>

      {/* Indicator dots */}
      <div className="absolute bottom-4 right-0 left-0">
        <div className="flex items-center justify-center gap-3">
          {videoSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => {
                setIsPlaying(false);
                setCurrent(i);
              }}
              className={`w-3 h-3 rounded-full transition-all duration-300 transform hover:scale-110
                ${current === i 
                  ? 'bg-primary-600 scale-110' 
                  : 'bg-white/70 hover:bg-white'}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideoGallerySliderComp;